import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TwoFactorAuthPage = () => {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('/api/auth/validate-2fa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // Inclui cookies
        body: JSON.stringify({ token }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.nextStep === 'home') {
          navigate('/home'); // Redireciona para a página Home
        }
      } else {
        setError('Código inválido ou expirado.');
      }
    } catch (err) {
      console.error('Erro ao validar 2FA:', err);
      setError('Erro ao validar o código. Tente novamente.');
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Verificação de 2FA</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="token">Insira o código enviado ao seu e-mail:</label>
        <br />
        <input
          type="text"
          id="token"
          name="token"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Código de autenticação"
          required
          style={{
            padding: '10px',
            margin: '10px 0',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: 'calc(100% - 22px)',
          }}
        />
        <br />
        <button
          type="submit"
          style={{
            backgroundColor: '#007BFF',
            color: 'white',
            padding: '10px 15px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          Validar
        </button>
      </form>
      {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
    </div>
  );
};

export default TwoFactorAuthPage;
